define(['backbone', 'models/Marketplace'], function(
  Backbone,
  MarketplaceModel
) {
  return Backbone.Collection.extend({
    model: MarketplaceModel
  });
});
